// extracted by mini-css-extract-plugin
export default {"upper-section":"SignUpPage_upper-section__PJP3d","body":"SignUpPage_body__IP8EZ"};